import { SettingsShell } from '@components/SettingsShell/SettingsShell'
import { Outlet, ScrollRestoration } from 'react-router-dom'

export interface SettingsLayoutProps {
  type: 'admin' | 'account'
}

export const SettingsLayout = (props: SettingsLayoutProps): JSX.Element => {
  const { type } = props

  return (
    <>
      <SettingsShell type={type} />
      <ScrollRestoration />
    </>
  )
}
